import MatterTasksCard from "@/components/features/matter/tasks/MatterTasksCard";
import { useTasksViewModel } from "@/hooks/matter-view-models/use-tasks-view-model";
import { useRedirectIfMatterDeleted } from "@/hooks/useRedirectIfMatterDeleted";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import type { Matter } from "@/lib/types";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/matters/$matterId/_layout/tasks")({
  component: RouteComponent,
  validateSearch: z.object({
    taskId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { matterId } = Route.useParams();
  // Get taskId from URL search params
  const { taskId } = useSearch({
    from: "/_auth/matters/$matterId/_layout/tasks",
  });
  const { data: matterDetails } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );
  const matterData = matterDetails.data as unknown;
  const isDeletedMatter =
    Array.isArray(matterData) ||
    !(matterData as { id?: string } | undefined)?.id;
  useRedirectIfMatterDeleted({ matterId, isDeletedMatter });
  if (isDeletedMatter) {
    return null;
  }

  return <MatterTasksContent matter={matterDetails.data} taskId={taskId} />;
}

const MatterTasksContent = ({
  matter,
  taskId,
}: {
  matter: Matter;
  taskId?: string;
}) => {
  const { allTasks } = useTasksViewModel(matter);

  return <MatterTasksCard tasks={allTasks} matter={matter} taskId={taskId} />;
};
